// extracted by mini-css-extract-plugin
export default {"header":"recommendations--37r3Q","header--highlighted":"recommendations--3rmBW"};